import { useQuery } from '@tanstack/react-query'
import { groups } from '../lib/api'
import type { BrowseParams } from '../types/community'

/** GET /groups/browse — network-wide discovery, re-fetched as the filters change. */
export function useBrowse(params: BrowseParams) {
  return useQuery({
    queryKey: ['community', 'browse', params.query ?? '', params.game ?? '', params.style ?? '', params.sort ?? ''],
    queryFn: () => groups.browseGroups(params),
    retry: false,
  })
}
